import { RouteObject } from "react-router-dom";
import { Module } from "../../assets/types/common";
import RequireAuth from "../../auth/requireAuth";
import { LookupCategoryDto } from "../../services/dto/admin/lookupCategoryDto";
import { LookupDto } from "../../services/dto/admin/lookupDto";
import { LookupGroupDto } from "../../services/dto/admin/lookupGroupDto";
import { LookupGroupContainer } from "../lookup/lookupgroup/lookupGroupContainer";
import { LookupTypeContainer } from "../lookup/lookuptype/lookupTypeContainer";
import { LookupValueContainer } from "../lookup/lookupvalue/lookupValueContainer";
import { PlanContainer } from "./plan/planContainer";
import { SubscriptionContainer } from "./subscription/subscriptionContainer";
import { SettingContainer } from "../setting/settingContainer";
import { SettingDto } from "../../services/dto/admin/settingDto";
import { permissions } from "../../assets/configuration/claimSettings";

export const AdminRoutes: RouteObject = {
    path: "admin",
    children: [
        {
            path: "subscription",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageSubscription]}>
                    <SubscriptionContainer />
                </RequireAuth>
            ),
        },
        {
            path: "plan",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManagePlan]}>
                    <PlanContainer />
                </RequireAuth>
            ),
        },
        {
            path: "lookuptype",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupTypeContainer<LookupCategoryDto> moduleType={Module.Admin} />
                </RequireAuth>
            ),
        },
        {
            path: "lookupgroup",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupGroupContainer<LookupGroupDto> moduleType={Module.Admin} />
                </RequireAuth>
            ),
        },
        {
            path: "lookupvalue",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <LookupValueContainer<LookupDto> moduleType={Module.Admin} />
                </RequireAuth>
            ),
        },
        {
            path: "settings",
            element: (
                <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
                    <SettingContainer<SettingDto> moduleType={Module.Admin} />
                </RequireAuth>
            ),
        },
    ],
};
